



































import { Vue, Inject, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { EventBus } from '@/event-bus';

@Component({
    props: ['cols', 'name', 'value', 'label', 'validate', 'type', 'notAfter', 'notBefore', 'disabled', 'editable', 'clearable', 'labelCols', 'showTime', 'tabindex']
})
export default class CustomDatePicker extends Vue  {  
  @Inject() parentValidator: any
    
    @Prop()
    name :any;
    
    @Prop({default: true})
    editable :any;

    @Prop({default: true})
    clearable :any;

    @Prop()
    validate :any;
    
    @Prop()
    labelCols :any;

    @Prop({default: ''})
    value :any;

    @Prop()
    tabindex: any;

    lCols : any = this.labelCols ? this.labelCols : 2;

    lang: string = 'ru';

    protected created() {
      this.$validator = this.parentValidator;
      this.lang = (localStorage.lang || 'Ru').toLowerCase();
      EventBus.$on('lang-changed', (lang: string) => {
        this.lang = lang;
      });
    }

    get isEditable() {
      if (this.editable === undefined) {
        return true;
      }
      return this.editable;
    }

    get isClearable() {
      if (this.clearable === undefined) {
        return true;
      }
      return this.clearable;
    }

    hasError() {
      return this.$validator.errors.has(this.name);
    }

    errorMessage() {
      return this.$validator.errors.first(this.name);
    }

    hasValidation() {
      return this.validate;
    }

    errorState(name: any) {
      return this.$validator.errors.has(name) ? false : null;
    }
}
